<template>
	<footer class="footer">
		<div class="footer_con min_cw">
			<ul class="nav footer_bottom_border">
				<li v-for="(item, index) in navOptions" :key="index">
					<AppLink :href="item.path">{{ item.title }}</AppLink>
				</li>
			</ul>

			<div class="links footer_bottom_border">
				<span class="label">友情链接：</span>
				<div class="list">
					<AppLink v-for="(item, index) in linkList" :key="index" class="item" :href="item.link_url">{{ item.link_name }}</AppLink>
				</div>
			</div>

			<div class="footer_c">
				<p>
					<span class="margin_sm_r">公司地址：{{ infoData.company_addr }}</span>
					<span class="margin_sm_r">邮政编码：{{ infoData.zip_code }}</span>
					<span>联系电话：{{ infoData.contact_phone }}</span>
				</p>
				<p class="links">
					<span class="margin_sm_r">{{ infoData.banquan }}</span>
          <span><AppLink href="https://beian.miit.gov.cn/" class="item">{{ infoData.web_filing }}</AppLink></span>
				</p>
			</div>
		</div>
	</footer>
</template>

<script>
import {mapGetters} from "vuex";
import {getCompanyInfoApi, getFriendLinkList} from "@/api";

export default {
	name: "index",
	data() {
		return {
			infoData: {},
			linkList: [],
		}
	},
	computed: {
		...mapGetters(["navOptions"])
	},
	created() {
		this.init();
	},
	methods: {
		init() {
			// 获取底部信息
			getCompanyInfoApi().then(res => {
				this.infoData = res.data;
			})

			/// 获取友情链接
			getFriendLinkList({ orderContent: "order_info asc", }).then(res => {
				this.linkList = res.data;
			})
		}
	}
}
</script>

<style lang="less" scoped>
.footer {
	flex-shrink: 0;
	width: 100%;
	height: @footHeight;
	background-color: #333333;

	.footer_con {
		width: 100%;
		height: 100%;
		padding: 24px 40px;
		display: flex;
		flex-direction: column;
		justify-content: space-around;
	}

	.nav {
		width: 100%;
		display: flex;
		align-items: center;

		>li {
			margin: 0 20px;
			font-size: 14px;
			color: @grey;
			line-height: 1.5;
		}

		>li:first-of-type {
			margin-left: 0;
		}

		>li:hover {
			color: @white;
		}
	}

	.footer_c {
		width: 100%;
		font-size: 14px;
		color: @grey;
		line-height: 1.5;
	}

	.footer_bottom_border {
		padding-bottom: 10px;
		border-bottom: 1px solid #444444;
	}

	.links {
		width: 100%;
		display: flex;
		align-items: center;

		.label {
			flex-shrink: 0;
			margin-right: 5px;
			font-size: 14px;
			color: @grey;
			line-height: 1.5;
		}

		.list {
			width: 100%;
		}

		.item {
			margin: 0 5px;
			font-size: 14px;
			color: @grey;
			line-height: 1.5;
		}

		.item:first-of-type {
			margin-left: 0;
		}

		.item:hover {
			color: @white;
			transform: scale(1.2);
		}
	}
}
</style>
